module.exports = __webpack_public_path__ + "static/media/default-video.f24ed2b6.webp";